import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

import { Address } from './address';
import { CarStorages } from './carStorage';
import { Comparable } from './comparable';
import { DisasterMitigation } from './disasterMitigation';
import { Encumbrance } from './encumbrance';
import { EnergyEfficiencyAndGreen } from './energyEfficiencyAndGreen';
import { EnvironmentalCondition } from './environmentalCondition';
import { HomeownersAssociations } from './homeownersAssociations';
import { Improvements } from './improvements';
import { Inspection } from './inspection';
import { ListingInformation } from './listingInformation';
import { LocationIdentifier } from './locationIdentifier';
import { Market } from './market';
import { Neighborhood } from './neighborhood';
import { Parcel } from './parcel';
import { ParcelSummary } from './parcelSummary';
import { Project } from './project';
import { PropertyAmenity } from './propertyAmenity';
import { PropertyDefect } from './defects';
import { PropertyDetail } from './propertyDetail';
import { PropertyGroundRent } from './propertyGroundRent';
import { PropertyNotUsed } from './propertyNotUsed';
import { PropertyTaxes } from './propertyTax';
import { PropertyUse } from './propertyUse';
import { PropertyValuation } from './propertyValuation';
import { RentalInformationSummary } from './rentalInformation';
import { Site } from './site';
import { Sales } from './sales';

export class PropertyUseSummary {
    constructor(doc)
    {
        this.label = null
        this.nonResidentialModificationIndicator = null
        this.nonResidentialUseDescription = null
        this.propertyMixedUsageIndicator = null
        this.propertyPrimarilyResidentialUseIndicator = null
        this.residentialUsePercent = null

        this.label = x.getStringAttribute(doc,"xlink:label");
        this.nonResidentialModificationIndicator = x.getBooleanElement(doc, "./ns:NonResidentialModificationIndicator");
        this.nonResidentialUseDescription = x.getStringElement(doc, "./ns:NonResidentialUseDescription");
        this.propertyMixedUsageIndicator = x.getBooleanElement(doc, "./ns:PropertyMixedUsageIndicator");
        this.propertyPrimarilyResidentialUseIndicator = x.getBooleanElement(doc, "./ns:PropertyPrimarilyResidentialUseIndicator");
        this.residentialUsePercent = x.getStringElement(doc, "./ns:ResidentialUsePercent");
   }
}

export class ListingInformationSummary {
    constructor(doc)
    {
        this.label = null
        this.cumulativeDaysOnMarketCount = null
        this.listedWithinPreviousYearIndicator = null

        this.label = x.getStringAttribute(doc,"xlink:label");
        this.cumulativeDaysOnMarketCount = x.getIntegerElement(doc, "./ns:CumulativeDaysOnMarketCount");
        this.listedWithinPreviousYearIndicator = x.getBooleanElement(doc, "./ns:ListedWithinPreviousYearIndicator");
   }
}

export class FunctionalIssue {
    constructor(doc)
    {
        this.label = null
        this.functionalIssueType = null
        this.functionalIssueTypeOtherDescription = null

        this.label = x.getStringAttribute(doc,"xlink:label");
        this.functionalIssueType = x.getStringElement(doc, "./ns:FunctionalIssueType");
        this.functionalIssueTypeOtherDescription = x.getStringElement(doc, "./ns:FunctionalIssueTypeOtherDescription");
   }

   GetType() {
    return h.descriptionOrOther(this.functionalIssueType, this.functionalIssueTypeOtherDescription);
   }
}

export class RealPropertyInterest {
    constructor(doc)
    {
        this.label = null
        this.appraisedIndicator = null
        this.propertyPartialInterestType = null
        this.propertyPartialInterestTypeOtherDescription = null

        this.label = x.getStringAttribute(doc,"xlink:label");
        this.appraisedIndicator = x.getBooleanElement(doc, "./ns:AppraisedIndicator");
        this.propertyPartialInterestType = x.getStringElement(doc, "./ns:PropertyPartialInterestType");
        this.propertyPartialInterestTypeOtherDescription = x.getStringElement(doc, "./ns:PropertyPartialInterestTypeOtherDescription");
   }
}

export class Property {
    constructor(doc) {
        //console.log("Property: ", doc);
        this.valuationUseType = null
        this.label = null
        this.additionalAddresses = []
        this.address = null
        this.carStorages = null;
        this.comparable = null
        this.disasterMitigation = null
        this.encumbrances = []
        this.energyEfficiencyAndGreen = null
        this.environmentalConditions = []
        this.functionalIssues = []
        this.homeownersAssociations = []
        this.improvements = [];
        this.inspections = []
        this.listingInformationSummary = null
        this.listingInformations = []
        this.locationIdentifier = null
        this.market = null
        this.neighborhood = null
        this.parcelSummary = null
        this.parcels = []
        this.project = null
        this.propertyAmenity = null
        this.propertyDefect = null
        this.propertyDetail = null
        this.propertyGroundRent = null
        this.propertyNotUsed = null
        this.propertyTaxes = []
        this.propertyUseSummary = null
        this.propertyUses = []
        this.propertyValuations = []
        this.realPropertyInterests = []
        this.rentalInformationSummary = null
        this.sales = null;
        this.site = null
        var node;
        var nodes;

        this.valuationUseType = x.getStringAttribute(doc,"ValuationUseType");
        this.label = x.getStringAttribute(doc,"xlink:label");
        nodes = x.selectNodes(doc, "./ns:ADDITIONAL_ADDRESSES/ns:ADDITIONAL_ADDRESS");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.additionalAddresses.push(new Address(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:ADDRESS");
        if (node !== null)
                this.address = new Address(node);

        node = x.selectSingleNode(doc, "./ns:CAR_STORAGES");
        if (node !== null)
            this.carStorages = new CarStorages(node);
    
        node = x.selectSingleNode(doc, "./ns:COMPARABLE");
        if (node !== null)
                this.comparable = new Comparable(node);

        node = x.selectSingleNode(doc, "./ns:DISASTER_MITIGATION_FEATURES");
        if (node !== null)
                this.disasterMitigation = new DisasterMitigation(node);

        nodes = x.selectNodes(doc, "./ns:ENCUMBRANCES/ns:ENCUMBRANCE");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.encumbrances.push(new Encumbrance(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:ENERGY_EFFICIENCY_AND_GREEN");
        if (node !== null)
                this.energyEfficiencyAndGreen = new EnergyEfficiencyAndGreen(node);
        nodes = x.selectNodes(doc, "./ns:ENVIRONMENTAL_CONDITIONS/ns:ENVIRONMENTAL_CONDITION");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.environmentalConditions.push(new EnvironmentalCondition(xn));
            });
        }
        nodes = x.selectNodes(doc, "./ns:FUNCTIONAL_ISSUES/ns:FUNCTIONAL_ISSUE");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.functionalIssues.push(new FunctionalIssue(xn));
            });
        }

        this.homeownersAssociations = new HomeownersAssociations(doc);
        this.improvements = new Improvements(doc, this);

        nodes = x.selectNodes(doc, "./ns:INSPECTIONS/ns:INSPECTION");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.inspections.push(new Inspection(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:LISTING_INFORMATION_SUMMARY");
        if (node !== null)
                this.listingInformationSummary = new ListingInformationSummary(node);
        nodes = x.selectNodes(doc, "./ns:LISTING_INFORMATIONS/ns:LISTING_INFORMATION");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.listingInformations.push(new ListingInformation(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:LOCATION_IDENTIFIER");
        if (node !== null)
                this.locationIdentifier = new LocationIdentifier(node);
        node = x.selectSingleNode(doc, "./ns:MARKET");
        if (node !== null)
                this.market = new Market(node);
        node = x.selectSingleNode(doc, "./ns:NEIGHBORHOOD");
        if (node !== null)
                this.neighborhood = new Neighborhood(node);
        node = x.selectSingleNode(doc, "./ns:PARCEL_SUMMARY");
        if (node !== null)
                this.parcelSummary = new ParcelSummary(node);
        nodes = x.selectNodes(doc, "./ns:PARCELS/ns:PARCEL");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.parcels.push(new Parcel(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:PROJECT");
        if (node !== null)
                this.project = new Project(node);
        node = x.selectSingleNode(doc, "./ns:PROPERTY_AMENITY");
        if (node !== null)
                this.propertyAmenity = new PropertyAmenity(node);
        node = x.selectSingleNode(doc, "./ns:PROPERTY_DEFECT");
        if (node !== null)
                this.propertyDefect = new PropertyDefect(node);
        node = x.selectSingleNode(doc, "./ns:PROPERTY_DETAIL");
        if (node !== null)
                this.propertyDetail = new PropertyDetail(node);
        node = x.selectSingleNode(doc, "./ns:PROPERTY_GROUND_RENT");
        if (node !== null)
                this.propertyGroundRent = new PropertyGroundRent(node);
        node = x.selectSingleNode(doc, "./ns:PROPERTY_NOT_USED");
        if (node !== null)
                this.propertyNotUsed = new PropertyNotUsed(node);

        node = x.selectSingleNode(doc, "./ns:PROPERTY_TAXES/ns:PROPERTY_TAX");
        if (node !== null)
            this.propertyTaxes = new PropertyTaxes(node);
    
        node = x.selectSingleNode(doc, "./ns:PROPERTY_USE_SUMMARY");
        if (node !== null)
                this.propertyUseSummary = new PropertyUseSummary(node);
        nodes = x.selectNodes(doc, "./ns:PROPERTY_USES/ns:PROPERTY_USE");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.propertyUses.push(new PropertyUse(xn));
            });
        }
        nodes = x.selectNodes(doc, "./ns:PROPERTY_VALUATIONS/ns:PROPERTY_VALUATION");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.propertyValuations.push(new PropertyValuation(xn));
            });
        }
        nodes = x.selectNodes(doc, "./ns:REAL_PROPERTY_INTERESTS/ns:REAL_PROPERTY_INTEREST");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.realPropertyInterests.push(new RealPropertyInterest(xn));
            });
        }
        node = x.selectSingleNode(doc, "./ns:RENTAL_INFORMATION_SUMMARY");
        if (node !== null)
                this.rentalInformationSummary = new RentalInformationSummary(node);

        this.sales = new Sales(doc);

        node = x.selectSingleNode(doc, "./ns:SITE");
        if (node !== null)
                this.site = new Site(node);
   }

    HasADU() {
        for (const i of this.improvements.improvementList) {
            if (i.HasADU()) return true;
        }
        return false
    }

    GetADUUnits() {
        let units = [];
        for (const i of this.improvements.improvementList) 
            for (var pu of i.propertyUnits)
                if (pu.IsADU()) units.push(pu);
                
        return units;
    }

    GetNonADUUnits() {
        let units = [];
        for (const i of this.improvements.improvementList) 
            for (var pu of i.propertyUnits)
                if (!pu.IsADU()) units.push(pu);
                
        return units;
    }

    GetAllUnits() {
        let units = [];
        for (const i of this.improvements.improvementList) 
            for (var pu of i.propertyUnits)
                units.push(pu);
                
        return units;
    }

    // Get unit by index
    GetUnitByIndex(ix) {
        for (const i of this.improvements.improvementList) {
            for (var pu of i.propertyUnits) {
                if (ix === 0) return pu;
                --ix;
            }
        }
        return null;
    }

    // Get unit by ID
    GetUnitById(id) {
        for (const i of this.improvements.improvementList) {
            for (const pu of i.propertyUnits) {
                if (pu.propertyUnitDetail.unitIdentifier === id) return pu;
            }
        }
        return null;
    }

    GetUnitByLabels(labels) {
        for (const i of this.improvements.improvementList) {
            let pu = i.GetUnitByLabels(labels);
            if (pu) return pu;
        }
        return null;
    }

    // Get graph images
    GetGraphImages() {
        const images = [];
        for (const inspection of this.inspections) {
            if (!inspection.label) {
                for (const image of inspection.images) {
                    if (image.imageCategoryType.endsWith("Graph")) {
                        images.push(image);
                    }
                }
            }
        }
        return images;
    }

    GetGraphImagesDescriptions() {
        const desc = [];
        for (const inspection of this.inspections) {
            if (!inspection.label) {
                for (const image of inspection.images) {
                    var type = image.imageCategoryType;
                    if (type.endsWith("Graph")) {
                        var descr = image.imageCaptionCommentDescription;
                        if (!descr) descr = h.toEnumText(type); 
                        desc.push(descr);
                    }
                }
            }
        }
        return desc;
    }


    // Get property image
    GetPropertyImage() {
        if (!this.inspections) return null;
        for (const inspection of this.inspections) {
            if (!inspection.label) {
                for (const image of inspection.images) {
                    if (image.imageCategoryType.endsWith("PropertyPhoto") ||
                        image.imageCategoryType.endsWith("DwellingFront")) {
                        return image;
                    }
                }
            }
        }
        return null;
    }

    // Get image by category
    GetImageByCategory(cat) {
        if (!this.inspections) return null;
        for (const inspection of this.inspections) {
            if (inspection.images) {
                for (const image of inspection.images) {
                    if (image.imageCategoryType === cat) return image;
                }
            }
        }
        return null;
    }

    GetImagesByCategory(cat) {
        let list = [];
        if (!this.inspections) return null;
        for (const inspection of this.inspections) {
            if (inspection.images) {
                for (const image of inspection.images) {
                    if (image.imageCategoryType === cat)
                        list.push(image);
                }
            }
        }
        return list;
    }

    GetImagesByCategories(catList) {
        let list = [];
        if (!this.inspections) return null;
        for (const inspection of this.inspections) {
            if (inspection.images) {
                for (const image of inspection.images) {
                    if (catList.includes(image.imageCategoryType))
                        list.push(image);
                }
            }
        }
        return list;
    }

    // Get inspection by label
    GetInspection(label) {
        for (const inspection of this.inspections) {
            if (inspection.label === label) return inspection;
        }
        return null;
    }

    // Check if all rights are included
    AllRightsIncluded() {
        if (!this.realPropertyInterests) return true;
        for (const interest of this.realPropertyInterests) {
            if (interest.propertyPartialInterestType) return false;
        }
        return true;
    }

    // Get alternative addresses
    GetAltAddresses() {
        if (this.additionalAddresses) {
            for (const adr of this.additionalAddresses) {
                return adr.GetFullAddressList();
            }
        }
        return [];
    }

    // Get non-residential uses
    GetNonResidentialUses() {
        let uses = "";
        if (this.propertyUses) {
            for (const pu of this.propertyUses) {
                uses = h.addWithSpacer(uses, pu.GetNonResidentialUse());
            }
        }
        return uses;
    }

    // Get construction status
    GetConstructionStatus() {
        return h.descriptionOrOther(this.propertyDetail.constructionStatusType, this.propertyDetail.constructionStatusTypeOtherDescription);
    }

    // Get construction methods
    GetConstructionMethods() {
        for (const i of this.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Dwelling") {
                return i.structure.GetConstructionMethods();
            }
        }
        return null;
    }

    // Check if it's a manufactured home
    IsManufacturedHome() {
        for (const i of this.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Dwelling") {
                if (i.structure.constructionMethods) {
                    for (const cm of i.structure.constructionMethods) {
                        if (cm.constructionMethodType === "Manufactured") return true;
                    }
                }
            }
        }
        return false;
    }

    // Get estate type
    GetEstateType() {
        return h.descriptionOrOther(this.propertyDetail.propertyEstateType, this.propertyDetail.propertyEstateTypeOtherDescription);
    }

    // Get encumbrances by type
    GetEncumbrancesByType(type) {
        if (!this.encumbrances) return null;
        switch (type) {
            case "ConditionsCovenantsRestrictions":
                for (const e of this.encumbrances) {
                    //console.log(e);
                    if (e.encumbranceDetail.encumbranceType === type) return e.conditionCovenantRestrictions;
                }
                break;
            case "DeedRestrictions":
                for (const e of this.encumbrances) {
                    if (e.encumbranceDetail.encumbranceType === type) return e.DeedRestrictions;
                }
                break;
            case "Easements":
                for (const e of this.encumbrances) {
                    if (e.encumbranceDetail.encumbranceType === type) return e.easements;
                }
                break;
            case "Encroachments":
                for (const e of this.encumbrances) {
                    if (e.encumbranceDetail.encumbranceType === type) return e.encroachments;
                }
                break;
            default:
                break;
        }
        return null;
    }


    // Get property restrictions
    GetPropertyRestrictions() {
        let result = "";
        if (!this.encumbrances) return "";
        for (const e of this.encumbrances) {
            if (e.conditionCovenantRestrictions) {
                for (const ccr of e.conditionCovenantRestrictions) {
                    result = h.addWithSpacer(result, ccr.GetCCRType());
                }
            }
        }
        return result;
    }


    GetEasements() {
        let result = '';
        if (!this.encumbrances) return '';
        for (const e of this.encumbrances) {
            if (!e.easements) continue;
            for (const ea of e.easements) {
                result = h.addWithSpacer(result, ea.GetEasementType());
            }
        }
        return result;
    }

    GetEasementsByType() {
        let result = [];
        if (!this.encumbrances) return '';
        for (const e of this.encumbrances) {
            if (!e.easements) continue;
            for (const ea of e.easements) {
                if (ea.GetEasementType === "Utility")
                    result.push(ea);
            }
        }
        return result;

    }

    GetEncroachments() {
        let result = '';
        if (!this.encumbrances) return '';
        for (const e of this.encumbrances) {
            if (!e.encroachments) continue;
            for (const en of e.encroachments) {
                result = h.addWithSpacer(result, en.GetEncroachmentType());
            }
        }
        return result;
    }

    GetFunctionalIssuesList() {
        const list = [];
        for (const af of this.functionalIssues) {
            if (af.functionalIssueType !== 'None') {
                list.push(af);
            }
        }
        return list;
    }

    GetFunctionalIssues() {
        let issues = '';
        if (this.functionalIssues.length === 0) return 'None';
        for (const af of this.functionalIssues) {
            if (af.functionalIssueType === 'None') return 'None';
            issues = h.addWithSpacer(issues, af.GetType());
        }
        return issues;
    }

    GetAmenityCategories() {
        const list = [];
        if (this.propertyAmenity.amenityCategories.length === 0) return list;
        for (const category of this.propertyAmenity.amenityCategories) {
            list.push(category.amenityCategoryDetail.amenityCategoryType);
        }
        return list;
    }

    GetAmenityList(category) {
        let list = '';
        if (this.propertyAmenity.amenityCategories.length === 0) return list;
        for (const category of this.propertyAmenity.amenityCategories) {
            if (category.amenityCategoryDetail.amenityCategoryType === category) {
                for (const amenity of category.amenities) {
                    let item = amenity.GetAmenityType();
                    item = h.addWithSpacer(item, amenity.GetSwimmingPoolFeatures(), ' - ');
                    if (amenity.amenityDetail.amenityCount > 0) {
                        item += ` - ${amenity.amenityDetail.amenityCount}`;
                    }
                    list = h.addWithSpacer(list, item);
                }
            }
        }
        return list;
    }

    GetAmenityByLabel(label) {
        if (!this.propertyAmenity) return null;
        for (const category of this.propertyAmenity.amenityCategories) {
            for (const amenity of category.amenities) {
                if (amenity.label === label) return amenity;
            }
        }
        return null;
    }

    GetAmenityImages() {
        const images = [];
        if (!this.propertyAmenity) return images;
		if (this.propertyAmenity.amenityCategories.length === 0) return images;

		for (let c of this.propertyAmenity.amenityCategories) {
			for (let amenity of c.amenities) {
                if (amenity.images.length > 0) {
                    for (const image of amenity.images) {
                        image.imageSourceCaption = amenity.GetAmenityType();
                        image.imageSourceCaption = h.addWithSpacer(image.imageSourceCaption, image.imageCaptionCommentDescription, ' - ');
                        images.push(image);
                    }
                }
            }
        }
        return images;
    }

    GetListPrice() {
        if (!this.listingInformations || this.listingInformations.length === 0) return 0;
        const listing = this.GetMostRecentListing();
        return listing.listingInformationDetail.finalListPriceAmount;
    }

    GetListingStatus() {
        if (!this.listingInformations || this.listingInformations.length === 0) return 'None';
        const listing = this.GetMostRecentListing();
        return h.toEnumText(listing.listingInformationDetail.listingStatusType);
    }

    GetListingByStatusTypeExcept(type) {
        if (!this.listingInformations || this.listingInformations.length === 0) return null;
        for (const li of this.listingInformations) {
            if (li.listingInformationDetail.listingStatusType !== type) return li;
        }
        return null;
    }

    GetMostRecentListing() {
        if (!this.listingInformations || this.listingInformations.length === 0) return null;
        if (this.listingInformations.length === 1) return this.listingInformations[0];
        let latest = this.listingInformations[0];

        for (const li of this.listingInformations) {
            if (h.isLaterThan(li.listingInformationDetail.listingStartDate, latest.listingInformationDetail.listingStartDate)) {
                latest = li;
            }
        }

        return latest;
    }

    GetAPNs() {
        let apns = '';
        if (this.parcels.length > 0) {
            for (const parcel of this.parcels) {
                if (parcel.parcelIdentifications) {
                    for (const pi of parcel.parcelIdentifications) {
                        if (pi.parcelIdentificationType === 'AssessorUnformattedIdentifier') {
                            apns = h.addWithNewline(apns, pi.parcelIdentifier);
                        }
                    }
                }
            }
        }
        return apns;
    }

    GetEnvironmentalConditionTypes() {
        var cond = "";
        if (this.environmentalConditions.length === 0) return null;
        for (var ec of this.environmentalConditions)
            cond = h.addWithSpacer(cond, ec.GetConditionType());

        return cond;
    }

    GetEnvironmentalCondition(type) {
        if (!this.environmentalConditions) return null;
        for (const ec of this.environmentalConditions) {
            if (ec.environmentalConditionType === type) return ec;
        }
        return null;
    }

    GetRenewableEnergyComponent() {
        let comp = '';
        if (!this.energyEfficiencyAndGreen) return null;
        if (!(this.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail?.renewableEnergyComponentExistsIndicator ?? false)) return "None";
        if (!this.energyEfficiencyAndGreen.renewableEnergyComponents) return null;
        for (const rec of this.energyEfficiencyAndGreen.renewableEnergyComponents) {
            comp = h.addWithSpacer(comp, rec.GetComponentType());
        }
        return comp;
    }

    GetBuildingCertification() {
        if (!this.energyEfficiencyAndGreen) return null;
        if (!(this.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail?.greenCertificationExistsIndicator ?? false)) return "None";
        return this.energyEfficiencyAndGreen.GetCertifications();
    }

    GetOutbuilding(index) {
        let ix = 0;
        for (const i of this.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Outbuilding" && i.improvementDetail.outbuildingType !== "StandaloneADU") {
                if (ix++ === index) return i;
            }
        }
        return null;
    }

    GetADULocation() {
        for (const i of this.improvements.improvementList) {
            for (const pu of i.propertyUnits) {
                if (pu.propertyUnitDetail?.accessoryDwellingUnitIndicator ?? false) {
                    if (i.improvementDetail.improvementType === "Dwelling") {
                        return "Dwelling";
                    } else if (i.improvementDetail.improvementType === "Outbuilding") {
                        if (i.outbuildingRealPropertyIndicator ?? false) {
                            return i.GetOutbuildingType();
                        }
                    }
                }
            }
        }
        return null;
    }

    GetDwellingStyles() {
        let dwellings = '';
        if (this.propertyDetail.attachmentType !== "Detached") return dwellings;
        for (const i of this.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Dwelling" && i.structure?.architecturalDesign) {
                dwellings = h.addWithSpacer(dwellings, i.structure.GetArchitecturalDesignType());
            }
        }
        return dwellings;
    }

    GetHasAttic() {
        for (const i of this.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Dwelling" && (i.structure?.structureDetail?.atticExistsIndicator ?? false)) {
                return true;
            }
        }
        return false;
    }

    GetGroundRentAmount() {
        if (!this.propertyGroundRent) return null;
        return this.propertyGroundRent.propertyGroundLeaseAnnualAmount;
    }

    GetNativeAmericanLandsType() {
        if (!(this.propertyDetail?.nativeAmericanLandsIndicator ?? false)) {
            return "No";
        } else {
            return h.descriptionOrOther(this.propertyDetail.nativeAmericanLandsType, this.propertyDetail.nativeAmericanLandsTypeOtherDescription);
        }
    }

    GetAppraisedIndicator() {
        var ind = false;
        if (!this.realPropertyInterests) return ind;
        for (const interest of this.realPropertyInterests) {
            if (!(interest.appraisedIndicator !== null)) {
                ind |= interest.appraisedIndicator;
            }
        }
        return ind;
    }

    GetRightsNotIncluded() {
        let rights = '';
        if (!this.realPropertyInterests) return rights;
        for (const interest of this.realPropertyInterests) {
            if (!(interest.appraisedIndicator ?? false)) {
                rights = h.addWithSpacer(rights, h.toEnumText(interest.propertyPartialInterestType));
            }
        }
        return rights;
    }

    GetDisasterMitigationFeaturesList() {
        var value = [];
        if (this.disasterMitigation.disasterMitigationFeatures.length === 0) return value;
        for (var d of this.disasterMitigation.disasterMitigationFeatures)
            value.push(d.GetFeatureType());

        return value;
        }

    GetUnitStandardAboveGradeFinishedAreaMeasureExists() {
        for (const i of this.improvements.improvementList) {
            for (const pu of i.propertyUnits) {
                if (pu.propertyUnitArea.unitStandardAboveGradeFinishedAreaMeasure.HasNonZeroValue()) return true;
            }
        }

        return false;
        }

    GetCostToRepairType() {
        if (!this.propertyDefect) return "";
        if (!this.propertyDefect.propertyDefectSummary) return "";
        return this.propertyDefect.propertyDefectSummary.costToRepairType;
    }

    GetCostToRepairTotalAmount() {
        if (!this.propertyDefect) return "";
        if (!this.propertyDefect.propertyDefectSummary) return "";
        return this.propertyDefect.propertyDefectSummary.defectCostToRepairTotalAmount;
    }
}

